var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',{staticClass:"press_release"},[_c('sliceheadline',{attrs:{"item":_vm.item}}),_c('slicetext',{attrs:{"text":_vm.text}}),_vm._l((_vm.body),function(slice){return _c('slice'+slice.slice_type,{key:slice.id,tag:"component",attrs:{"item":_vm.item,"slice":slice}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }